import { FC, useContext, useEffect, useMemo, useState } from 'react'
import { useForm } from 'react-hook-form'
import { IUser } from '@contexts/user/user.utils'
import { UserContext } from '@contexts/user/user.context'
import { useModalAction } from '@components/common/modal/modal.context'
import { useTranslation } from 'next-i18next'
import dateFormat from 'dateformat'
import { RiArrowDownSLine } from 'react-icons/ri'
import { useMutation } from 'react-query'
import pdpQuestionAnswersService from '@services/pdp-questionanswer-service'
import { toast } from 'react-toastify'
import { AxiosResponse } from 'axios'
import AddAnswerForm from './add-answers'
import OutlineButton from '@components/ui/outline-button'
import { ROUTES } from '@utils/routes'
import { useRouter } from 'next/router'
interface QuestionAndAnswersProps {
  data: any
  product_id: string
}

interface LikeDislikeResponse {
  status: boolean
  message: string
  // Add other properties as needed
}

const QuestionAndAnswers: FC<QuestionAndAnswersProps> = (props) => {
  const router = useRouter()
  const { isGuest, user } = useContext(UserContext) as IUser
  const { t } = useTranslation()
  const tabHeading = ['text-customer-reviews', 'text-question-and-answers']

  const { openModal } = useModalAction()

  function handleLogin() {
    router.push(ROUTES?.LOGIN)
  }

  const onClick = () => {
    openModal('ASK_QUESTION')
  }

  const { data, product_id } = props

  // const dispatch = useDispatch()
  const [filterData, setFilterData] = useState(data)
  // const [newQuestion,setNewQuestion] = useState('');

  const [expand, setExpandItems] = useState([])
  const [expandQuestion, setExpandQuestion] = useState(false)
  const [feedback, setfeedBackList] = useState([])
  const [addAnswer, setAddAnswer] = useState([])
  // const { isGuest, customer_name, id } = useContext(UserContext)
  // const { register, handleSubmit } = useForm({
  //   resolver: yupResolver(schema),
  // })

  useEffect(() => {
    // if(data && data.length){
    //     data.map(({answers})=>{

    //     })
    // }
    setFilterData(data)
  }, [data]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (localStorage.getItem('answer-like-dislike')) {
      setfeedBackList(JSON.parse(localStorage.getItem('answer-like-dislike')))
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const AddAnswer = (form) => {
    if (form.message) {
      // const answers = data[]
      qAService
        .addAnswer(form.question_id, customer_name, id, '3', form.message)
        .then((res) => {
          setAddAnswer([])
        })
    }
  }

  const filterDataClick = (filter) => {
    let newData = [...data]

    if (filter.tag) {
      newData = newData.filter(({ tags }) => tags.includes(filter.tag))
    }
    if (filter.question) {
      newData = newData.filter(({ question }) =>
        question.toUpperCase().includes(filter.question.toUpperCase()),
      )
    }
    setFilterData(newData)
  }

  const tagsList = useMemo(() => {
    if (data?.length) {
      let tagsList = []
      return data?.map((item, index) => {
        if (!item || !item.tags) return null

        let { tags } = item

        if (tags.includes(',')) {
          tags = tags.split(',')
        } else {
          tags = [tags]
        }
        return tags.map((tag) => {
          if (tagsList.includes(tag)) return null
          tagsList.push(tag)
          return (
            <div
              onClick={() => filterDataClick({ tag })}
              className="flex flex-wrap gap-2"
            >
              <span className="bg-gray-200 text-gray-700 px-2 py-1 rounded-full text-sm">
                {tag}
              </span>
            </div>
          )
        })
      })
    }
  }, [data])

  const { mutate } = useMutation(
    ({ like, answer_id }: { like: boolean; answer_id: string }) => {
      return pdpQuestionAnswersService.likeDislike(like, answer_id)
    },
    {
      onSuccess: (
        response: AxiosResponse<LikeDislikeResponse>,
        variables: { like: boolean; answer_id: string },
      ) => {
        if (response.status) {
          const { answer_id } = variables
          localStorage.setItem(
            'answer-like-dislike',
            JSON.stringify([answer_id, ...feedback]),
          )
          setfeedBackList([answer_id, ...feedback])
        }
      },
      onError: (err: Error) => {
        toast.error(`Error submitting question: ${err.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-error',
        })
      },
    },
  )

  // eslint-disable-line react-hooks/exhaustive-deps
  const LikeDislike = (like, answer_id) => {
    mutate({ like, answer_id })
    // qAService.likeDislike(like, answer_id).then((res) => {
    //   localStorage.setItem(
    //     'answer-like-dislike',
    //     JSON.stringify([answer_id, ...feedback]),
    //   )
    //   setfeedBackList([answer_id, ...feedback])
    // })
  }

  const expadnClick = (question_id, remove) => {
    const newItem = [...expand]
    if (!remove) newItem.push(question_id)
    else newItem.splice(newItem.indexOf(question_id), 1)
    setExpandItems(newItem)
  }

  // const onSubmit = (data) => {

  // qAService
  //   .addQuestion(product_id, 1, data.message, customer_name)
  //   .then((res) => {
  //     dispatch(
  //       setDialogData({
  //         props: {
  //           open: false,
  //         },
  //       }),
  //     )
  //     if (!window.FsdApp) return
  //     window.FsdApp.getController('dialog').notify({
  //       text: 'Thank you for your question, it will be reviewed and posted shortly',
  //       theme: 'success',
  //     })
  //   })
  // }

  const addQuestion = () => {
    openModal('ASK_QUESTION', { product_id })
  }

  if (!filterData) return null
  if (!data?.length && !filterData?.length)
    return (
      <div className="p-5 pt-10 text-center">
        <p>No questions and answers found for this product</p>
        {isGuest ? (
          <p className="py-3">
            Please{' '}
            <a
              className="text-brand font-medium underline cursor-pointer"
              onClick={handleLogin}
            >
              sign in
            </a>{' '}
            to ask a question
          </p>
        ) : (
          <OutlineButton
            className="w-[140px] md:w-[180px] hover:bg-brand-light rounded  h-[50px] mt-5  px-3 text-brand-dark  whitespace-nowrap"
            onClick={addQuestion}
          >
            Ask a Question ?
          </OutlineButton>
        )}
      </div>
    )

  return (
    <div className="container box-shadow bg-brand-light mx-auto px-4 py-8 mt-5">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 grid-col">
        {/* Left Column for Questions and Answers */}
        <div className="order-2 md:order-1 lg:col-span-2 space-y-4">
          <div className="c-questions-answers__before">
            <div className="c-questions-answers__questions-list">
              <ul className="c-questions-answers__questions-list-items">
                {filterData?.map((item, questionIndex) => {
                  if (!item) return null
                  // Destructure after ensuring item is valid
                  const { question_id, question, answers, tags } = item
                  if (!expandQuestion && questionIndex > 1) return null
                  return (
                    <li className="border-b border-gray-200 py-4">
                      <h2 className="font-semibold text-lg text-brand-dark break-words">
                        {question}
                      </h2>

                      {answers.map(
                        (
                          {
                            answer,
                            answer_id,
                            created_by,
                            like,
                            dislike,
                            customer_name,
                            created_at,
                            customer_id,
                          },
                          index,
                        ) =>
                          index === 0 || expand.includes(question_id) ? (
                            <>
                              <div className="mt-2">
                                {index === 0 ? (
                                  <span className="text-xs text-gray-500 break-words">
                                    Best Answer:{' '}
                                  </span>
                                ) : (
                                  ''
                                )}
                                <span className="text-sm text-gray-900 font-semibold break-words">
                                  {' '}
                                  {answer}
                                </span>
                              </div>

                              <div className="flex items-center mt-2 text-xs text-gray-500">
                                <span className="text-brand underline">
                                  {customer_id === user?.id
                                    ? 'You'
                                    : customer_name}
                                </span>
                                <span className="mx-2">•</span>
                                <span>
                                  {dateFormat(
                                    created_at.replace(' ', 'T'),
                                    'mediumDate',
                                  )}
                                </span>
                                <span className="ml-2 font-bold bg-orange-600 text-white px-2 py-1 rounded text-xs">
                                  {created_by}
                                </span>
                              </div>

                              {!feedback.includes(answer_id) ? (
                                <div className="flex items-center mt-2 text-sm">
                                  <span className="mr-2 font-medium whitespace-nowrap text-brand-dark">
                                    Was Helpful?
                                  </span>
                                  <div className="flex items-center space-x-2 text-gray-400">
                                    <span
                                      className="cursor-pointer text-xl"
                                      onClick={() =>
                                        LikeDislike(true, answer_id)
                                      }
                                    >
                                      😊
                                    </span>
                                    <span
                                      className="cursor-pointer text-xl"
                                      onClick={() =>
                                        LikeDislike(false, answer_id)
                                      }
                                    >
                                      🙁
                                    </span>
                                  </div>
                                  <span className="ml-2 text-xs text-gray-500">
                                    {like} people found this helpful
                                  </span>
                                </div>
                              ) : (
                                <div className="mt-2 flex items-center">
                                  <span className="text-xl">😊</span>
                                  <span className="ml-2 text-brand text-sm font-medium">
                                    Thank you for your feedback
                                  </span>
                                </div>
                              )}
                            </>
                          ) : (
                            ''
                          ),
                      )}

                      <div>
                        {answers.length > 1 && (
                          <div className="mt-2 text-brand cursor-pointer font-medium flex items-center">
                            {!expand.includes(question_id) ? (
                              <span
                                className="underline"
                                onClick={() => expadnClick(question_id)}
                              >
                                Read all {answers.length} Answers
                              </span>
                            ) : (
                              <span
                                className="underline"
                                onClick={() => expadnClick(question_id, true)}
                              >
                                Show Less
                              </span>
                            )}
                            <RiArrowDownSLine
                              className="text-brand"
                              fontSize={28}
                            />
                          </div>
                        )}
                        {(!isGuest && !addAnswer.includes(question_id) && (
                          <div
                            className="font-medium flex items-center"
                            onClick={() => setAddAnswer(question_id)}
                          >
                            <span className="text-brand underline cursor-pointer">
                              Add Answer
                            </span>
                            <RiArrowDownSLine
                              className="text-brand"
                              fontSize={28}
                            />
                          </div>
                        )) ||
                          ''}
                      </div>
                      {addAnswer?.includes(question_id) ? (
                        <AddAnswerForm
                          setAddAnswer={setAddAnswer}
                          question_id={question_id}
                        />
                      ) : (
                        ''
                      )}
                    </li>
                  )
                })}
              </ul>
            </div>
            {/* <div className="c-questions-answers__mobile-action">
                                <button className="c-button c-button--full-width">See all 26 Questions</button>
                            </div> */}
          </div>
        </div>
        {/* Right Column for Search and Trending */}
        <div className="order-1 md:order-2 space-y-8">
          <div className="c-questions-answers__after">
            <div className="c-questions-answers__box mb-3">
              {/* Search Box */}
              <div className="bg-gray-100 p-6 rounded-lg">
                <h3 className="font-semibold mb-2 text-brand-dark">
                  Have a question about this?
                </h3>
                <div className="relative">
                  <input
                    onChange={(e) =>
                      filterDataClick({ question: e.target.value })
                    }
                    type="text"
                    placeholder="Search for answers"
                    className="w-full px-4 text-[16px] py-2 border border-gray-300 rounded-lg"
                  />
                  <button className="absolute right-2 top-2 text-brand">
                    🔍
                  </button>
                </div>

                <p className="text-sm mt-2">
                  Search for frequently asked questions in the box above, or{' '}
                  <a href="#" className="text-brand">
                    click here
                  </a>{' '}
                  to contact us
                </p>
              </div>
            </div>
            <div className="py-3">
              {!isGuest && (
                <a
                  onClick={addQuestion}
                  className="text-brand font-medium underline"
                  href="#/"
                >
                  Ask a Question ?
                </a>
              )}
            </div>
            {isGuest && (
              <p className="mb-3">
                Please{' '}
                <a
                  className="text-brand underline cursor-pointer"
                  onClick={handleLogin}
                >
                  sign in
                </a>{' '}
                here to ask a question
              </p>
            )}
            {/* Trending Section */}
            <div className="space-y-2">
              <h4 className="font-semibold text-brand-dark">Trending</h4>
              {tagsList}
            </div>
          </div>
        </div>
      </div>
      {/* Show More / Show Less */}
      {filterData?.length > 2 ? (
        <div
          onClick={() => setExpandQuestion(!expandQuestion)}
          className="mt-4 flex justify-center"
        >
          <span className="text-brand cursor-pointer font-medium underline">
            {!expandQuestion
              ? `See all ${filterData.length} Questions`
              : 'Show Less'}
          </span>
          <RiArrowDownSLine className="text-brand rota" fontSize={28} />
        </div>
      ) : (
        ''
      )}
    </div>
  )
}

export default QuestionAndAnswers
